import { IActivityBase } from '../../models/activities';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateVentureAvatarsProps {
  ventureId: string;
  avatarData: FormData;
}

export interface IUpdatedVentureAvatar extends IVentureBase {
  activities?: IActivityBase[];
}

export const updateVentureAvatarsService = async ({
  avatarData,
  ventureId,
}: IUpdateVentureAvatarsProps): Promise<IUpdatedVentureAvatar> => {
  const { data } = await jhsfBookingsApi.patch<IUpdatedVentureAvatar>(
    `/avatars/ventures/${ventureId}`,
    avatarData,
  );

  return data;
};
